import { useState } from 'react';
import { axiosInstance } from '@/shared/api/axiosInstance';
import { useAppDispatch } from '@/shared/lib/hooks/useAppDispatch';
import { loginSuccess, User } from '@/features/auth/model/authSlice';
import { passQuestionnaire } from '@/features/questionnaire/model/questionnaireSlice';
import { fetchLatestRiskResult } from '@/features/questionnaire/model/questionnaireSlice';


export const useLogin = () => {
    const dispatch = useAppDispatch();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const login = async (email: string, password: string): Promise<boolean> => {
        setLoading(true);
        setError(null);

        try {
            // 1. Авторизация
            const response = await axiosInstance.post('/auth/login', {
                email,
                password,
            });

            const accessToken = response.data.access_token;
            const payload = JSON.parse(atob(accessToken.split('.')[1])); // Расшифровка JWT

            // 2. Установка токена
            axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;

            // 3. Запрос профиля
            const profileResponse = await axiosInstance.get('/auth/me');
            const profile = profileResponse.data;

            const user: User = {
                id: profile.id,
                firstName: profile.first_name,
                lastName: profile.surname,
                email: profile.email,
                phone: '', // Можно добавить если есть
            };

            dispatch(loginSuccess({
                token: accessToken,
                user,
            }));

            // 4. Если прошёл тест — сохранить это
            if (profile.is_actual) {
                dispatch(passQuestionnaire());
                await dispatch(fetchLatestRiskResult());
            }

            return true;
        } catch (e: any) {
            console.error('Ошибка авторизации:', e.response?.data || e.message);
            setError('Неверный email или пароль');
            return false;
        } finally {
            setLoading(false);
        }
    };

    return { login, loading, error };
};
